import type { SxProps, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { monoSx } from '../dashboard/styles';

// Hoisted so every render reuses the same objects.
export const cardSx: SxProps<Theme> = {
  bgcolor: 'background.paper',
  border: 1,
  borderColor: 'divider',
  borderRadius: 4,
  p: { xs: 2, sm: 3 },
};

/** Grey well behind each editable row (package, item). */
export const rowWellSx: SxProps<Theme> = {
  p: 0.5,
  borderRadius: 2.5,
  bgcolor: (theme) => alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.04 : 0.08),
};

/** 44px outlined input matching the reference design. */
export const inputSx: SxProps<Theme> = {
  height: 44,
  width: '100%',
  borderRadius: 2,
  fontSize: 14,
  bgcolor: 'background.paper',
};

/** 40px variant used inside row wells. */
export const denseInputSx: SxProps<Theme> = { ...(inputSx as object), height: 40 };

export const monoInputSx: SxProps<Theme> = { ...(monoSx as object), fontSize: 13 };

export const numericInputProps = { inputMode: 'decimal' as const, style: { fontVariantNumeric: 'tabular-nums' } };

/** Rounded outlined "add row" button. */
export const addButtonSx: SxProps<Theme> = {
  height: 36,
  px: 1.75,
  borderRadius: 18,
  fontSize: 13,
  fontWeight: 600,
  borderColor: 'divider',
  color: 'primary.dark',
  bgcolor: 'background.paper',
  '&:hover': { bgcolor: 'brand.container', borderColor: 'transparent' },
};
